import axios from 'axios';
import moment from 'moment';
import api from "../../../libs/api";

angular
  .module("AccountingBoxApp")
  .controller("PurchasesEditCtrl", function(
    $scope,
    $rootScope,
    $timeout,
    $state,
    $stateParams,
    Purchase,
    $filter,
    Vendor,
    LoopBackAuth,
    Account,
    VatCode,
    Attachment,
    SubAccount
  ) {
    var vm = this;
    let attachment = {};
    var vendors = [];
    var subAccounts;
    vm.extractedWords = [];
    vm.extractedNumbers = [];
    vm.purchase = new Purchase();
    vm.total = null;
    vm.exchangeRates = []

    async function refreshExchangeRates() {
      try {
        const result = await axios.get(API_ENDPOINT + '/exchange-rates?date='+moment(vm.purchase.invoiceDate).format('YYYY-MM-DD'),{})
        vm.exchangeRates = result.data;
        vm.currencyChanged();
      } catch (e) {
        if (vm.purchase.currency !== "EUR") {
          console.log('e',e.response.data.error.message);
          window.swal(
            e.response.data.error.message, "",
            "error"
          );
        }
      }
    }

    vm.typeChanged = function() {
      if (vm.purchase.type === "receipt") {
        if (vm.purchase.Attachment?.transactionProposal.time) {
          vm.purchase.time = vm.purchase.Attachment?.transactionProposal.time;
        } else if (vm.purchase.Attachment?.extractedData?.times?.length === 1) {
          vm.purchase.time = vm.purchase.Attachment?.extractedData?.times[0];
        }
      }
    }

    vm.currencyChanged = function currencyChanged () {
      if (vm.purchase.currency === "EUR") {
        vm.purchase.currencyExchangeRate = 1
      }else {
        vm.purchase.currencyExchangeRate = vm.exchangeRates[vm.purchase.currency]
      }
      vm.totalChanged()
      $scope.$apply();
    }

    function refreshVendorPurchaseCount(vendor) {
      Purchase.count({where: {
          vendorId: vendor.id,
          companyId: $rootScope.currentCompany.id
        }}).$promise.then(function(count) {
        if(vm.purchase && vm.purchase.vendor) {
          vm.purchase.vendor.purchaseCount = count.count;
        }
      });
    }

    vm.totalLocalAccountCount = 0;
    vm.totalLocalVatCodeCount = 0;
    vm.accountsByAccountNumber = {}

    vm.getLocalAccountCount = function(account) {
      if(!account) return 0;
      let accountWithStats = vm.accountsByAccountNumber[account.accountNumber];
      if(!accountWithStats) return 0;
      return accountWithStats.localCount;
    }

    vm.getLocalVatCodeCount = function(vatCode) {
      if(!vatCode) return 0;
      let vatCodeWithStats = vm.vatCodes?.find(v => v.vatCode === vatCode.vatCode);
      if(!vatCodeWithStats) return 0;
      return vatCodeWithStats.localCount;
    }
    function refreshAccounts(changeAccounts) {
      var callback = function(accounts) {
        $timeout(function() {
          vm.accounts = accounts;
          if(vm.purchase.totalAmount > 450)  {
            vm.accounts = _.sortBy(vm.accounts, function(account) {
              return account.description.match(/\(investering\)/i) && (account.localCount > 0 || account.globalCount > 5) ? 0 : 1;
            });
          }
          vm.accountsByAccountNumber = {};
          vm.accounts.forEach(function(account) {
            vm.accountsByAccountNumber[account.accountNumber] = account;
          });
          vm.totalLocalAccountCount = accounts.reduce(function(a, b) {
            return a + b.localCount;
          }, 0);
          vm.initializeL(changeAccounts);
        }, 10);
      };
      let vendorId = null;
      if (vm.purchase.vendor && vm.purchase.vendor.id) {
        vendorId = vm.purchase.vendor.id;
        refreshVendorPurchaseCount(vm.purchase.vendor);
      }
      Vendor.orderedAccounts({ vendorId }, callback);
    }

    async function refreshVatCodes() {
      const vatCodes  = await api.get('/Vendors/ordered-vat-codes', {
        params: {
          vendorId: vm.purchase?.vendor?.id
        }});

      vm.vatCodes = vatCodes;
      vm.totalLocalVatCodeCount = vatCodes.reduce(function(a, b) {
        return a + b.localCount;
      }, 0);

      if(vm.purchase?.Lines) {
        vm.purchase.Lines = vm.purchase.Lines.map(function(line) {
          if(line.vatCodeId?.startsWith('V-'))  {
            if(line.vatCodeId.match(/V-NL-H|V-NL-L|V-NL-0%/)) {
              line.vatCodeId = line.vatCodeId.replace('V-NL-', 'I-NL-')
            }else {
              line.vatCodeId = null;
            }
          }
          line.vatCode = vm.vatCodes.find(function(vatCode) {
            return vatCode.vatCode === line.vatCodeId;
          }) || null;
          return line;
        });
      }

      return vatCodes;
    }

    $timeout(function() {
      loadVendors();
      vm.refreshSubAccounts();
      vm.vatCodes = [];
      refreshVatCodes().then(function(vatCodes) {
        vm.vatCodes = vatCodes;
        console.log("loaded vat codes");
        refreshAccounts();
      }).catch((e)=> {
        console.log('e',e)
      });
    }, 0);

    vm.refreshSubAccounts = function() {
      SubAccount.find(function(subA) {
        subAccounts = subA;
      });
    };

    vm.subAccountsPartners = function() {
      return _.filter(subAccounts, function(a) {
        return a.type === 'PARTNER';
      });
    }

    vm.subAccountsFiltered = function(item) {
      if (item && item.account) {
        var aN = item.account.accountNumber;
        var subAccountType = vm.subAccountType(item);
        return _.filter(vm.subAccounts, function(a) {
          return a.type === subAccountType;
        });
      } else {
        return vm.subAccounts;
      }
    };

    vm.subAccountType = function(item) {
      var aN = 0;
      if (item && item.account) {
        aN = item.account.accountNumber;
      }
      if (
        (aN >= 213000 && aN <= 213030) ||
        aN == 4102070 ||
        aN == 4106070 ||
        (aN >= 4205000 && aN <= 4205990)
      ) {
        return "VEHICLE";
      } else if (
        (aN >= 509000 && aN <= 509080) ||
        aN == 1103140 ||
        aN == 1103120 ||
        aN == 1209010 ||
        aN == 1209020 ||
        aN == 9005010 ||
        aN == 306010 ||
        aN == 806030 ||
        aN == 8401060 ||
        aN == 8401070 ||
        aN == 8404130 ||
        aN == 8404140 ||
        aN == 4203110
      ) {
        return "PARTNER";
      } else if (
        aN == 301010 ||
        aN == 305010 ||
        aN == 504070 ||
        aN == 8401010 ||
        aN == 8404080 ||
        aN == 8410010
      ) {
        return "PARTICIPATION";
      } else if (
        (aN >= 100000 && aN <= 218030) ||
        (aN >= 4100000 && aN <= 4199030)
      ) {
        return "INVESTMENT";
      } else {
        return "MISCELLANEOUS";
      }
    };

    vm.subAccountSelect = function(subAccount, item) {
      if (subAccount && subAccount.new) {
        SubAccount.create(subAccount, function(subAccount) {
          item.subAccount = subAccount;
          item.subAccountId = subAccount.id;
          SubAccount.find(function(subA) {
            subAccounts = subA;
          });
        });
      }else {
        item.subAccount = subAccount;
        item.subAccountId = (subAccount && subAccount.id) || null;
      }
    };

    // FIXME in case of two subaccounts with the same name it wont won't Zeon energy "Diverse kantoor benodigheden"
    vm.refreshSubAccount = function(query, item) {
      vm.subAccounts = $filter("propsFilter")(subAccounts, {
        description: query
      });
      if (vm.subAccounts && query.length > 0) {
        vm.subAccounts.push({
          description: query,
          new: true,
          type: vm.subAccountType(item)
        });
      }
    };

    vm.accountChanged = function(item) {
      var type = vm.subAccountType(item);
      if (type === "INVESTMENT") {
        if (!vm.showExtra(item)) {
          vm.checkExtra(item);
          if (!item.destination) {
            item.destination = {};
          }
          item.destination.numberOfMonths = 60;
          if (item.account.accountNumber === 107010) {
            item.destination.numberOfMonths = 120;
          }
          item.destination.residualValue = 0;
        }
      }
    };

    vm.token = LoopBackAuth.accessTokenId;

    $scope.accountGroup = function(item) {
      if (!item.subCategory) return "";
      return item.subCategory.description;
    };

    vm.calculateItem = function(item) {
      var calculation = item.amount;
      if (calculation.indexOf("=") > -1) {
        calculation = calculation.replace("=", "");
        item.amount = roundTwoDecimals(parseFloat(eval(calculation)));
      } else if (
        calculation.indexOf("+") === -1 &&
        calculation.indexOf("-") === -1 &&
        calculation.indexOf("+") === -1 &&
        calculation.indexOf("*") === -1 &&
        calculation.indexOf("(") === -1 &&
        calculation.indexOf(")") === -1 &&
        calculation.indexOf(" ") === -11 &&
        calculation.indexOf(".") === -1 &&
        calculation.indexOf(",") === -1
      ) {
        item.amount = roundTwoDecimals(parseFloat(calculation));
      }
    };

    vm.showExtra = function(item) {
      if (
        (item.description && item.description.length > 0) ||
        item.subAccount ||
        (item.destination && item.destination.account) ||
        (item.destination && item.destination.numberOfMonths) ||
        (item.destination && item.destination.residualValue) ||
        item.showExtra
      ) {
        return true;
      } else {
        return false;
      }
    };

    vm.checkExtra = function(item) {
      if (item.showExtra) {
        item.showExtra = false;
      } else if (!item.showExtra) {
        item.showExtra = true;
      }
    };

    vm.close = function(saved) {
      if ($state.current.name === "app.company.new.purchases") {
        if (saved) {
          $scope.openNextUpload()
        } else {
          $state.go("app.company.inbox");
        }
      } else {
        window.history.back();
      }
    };

    $scope.$on("close", function() {
      vm.close();
    });

    vm.enteredInvoiceNumber = function checkUnique() {
      if (
        $state.current.name === "app.company.new.purchases" &&
        vm.purchase.vendor &&
        vm.purchase.invoiceNumber
      ) {
        Purchase.find(
          {
            filter: {
              where: {
                invoiceNumber: vm.purchase.invoiceNumber,
                vendorId: vm.purchase.vendor.id
              }
            }
          },
          function(purchases) {
            if (purchases.length > 0) {
              var options = {
                style: "flip",
                type: "danger",
                position: "top-right",
                message:
                  "Er bestaat al een inkoopfactuur met factuurnummer <strong>" +
                  vm.purchase.invoiceNumber +
                  "</strong> van <strong>" +
                  vm.purchase.vendor.name +
                  "</strong>"
              };
              $("body")
                .pgNotification(options)
                .show();
            }
          }
        );
      }
    };

    vm.invoiceDateChanged = function() {
      if (!vm.purchase.invoiceDate) return;
      refreshExchangeRates()
      vm.purchase.journalDate = vm.purchase.invoiceDate;
      var invoiceDate = moment(vm.purchase.invoiceDate);
      var dueDateInterval = 14;

      if (
        vm.purchase.vendor &&
        (vm.purchase.vendor.paymentTerm || vm.purchase.vendor.paymentTerm === 0)
      ) {
        dueDateInterval = vm.purchase.vendor.paymentTerm;
      }
      if (
        attachment &&
        attachment.extractedData &&
        attachment.extractedData.paymentTerm
      ) {
        dueDateInterval = attachment.extractedData.paymentTerm;
      }
      if (vm.purchase.type === "receipt") {
        dueDateInterval = 0;
      }
      var dueDate = invoiceDate.add(dueDateInterval, "days");
      if (
        attachment &&
        attachment.transactionProposal &&
        attachment.transactionProposal.dueDate
      ) {
        dueDate = moment(attachment.transactionProposal.dueDate);
      }
      vm.purchase.dueDate = dueDate;
      vm.totalChanged();
    };

    vm.focus = function(index) {
      if (vm.purchase.Lines.length - 1 === index) {
        vm.addItem();
      }
    };

    vm.addItem = function() {
      if (!vm.purchase.Lines) {
        vm.purchase.Lines = [];
      }

      var defaultVatCode = "I-NL-H";
      //first line only
      if (attachment.extractedData && vm.purchase.Lines.length === 0) {
        var vatType = null;
        // if (attachment.extractedData.vat) {
        //   vatType = attachment.extractedData.vat.type;
        // }

        switch (vatType) {
          case "high":
            defaultVatCode = "I-NL-H";
            break;
          case "low":
            defaultVatCode = "I-NL-L";
            break;
          case "zero":
            defaultVatCode = "I-NL-0%";
            break;
          default:
            defaultVatCode = null;
            break;
        }
      }
      if ($rootScope.currentCompany.vatPeriod === "EXEMPTED") {
        defaultVatCode = "I-NL-NVT";
      }
      if ($rootScope.currentCompany.vatPeriod === "EXEMPTED_KOR") {
        defaultVatCode = "I-NL-KOR";
      }
      var defaultVatCode =
        vm.vatCodes.find(function(vatCode) {
          return vatCode.vatCode === defaultVatCode;
        }) || null;

      var line = {
        description: "",
        amount: 0,
        vatCode: defaultVatCode
      };
      if (
        vm.accounts &&
        (vm.accounts[0].localCount > 0 || vm.accounts[0].globalCount > 0)
      ) {
        line.account = vm.accounts[0];
      }
      vm.purchase.Lines.push(line);
    };

    vm.removeItem = function(item) {
      vm.purchase.Lines.splice(vm.purchase.Lines.indexOf(item), 1);
      if (vm.purchase.Lines.length === 0) {
        vm.addItem();
      }
    };

    function roundTwoDecimals(number) {
      return Math.round(number * 100) / 100;
    }

    vm.vatCodeChanged = function() {
      vm.totalChanged();
    };

    vm.destinationAccountChanged = function(item) {
      if (item.account.accountNumber === 1104010) {
        item.destination.numberOfMonths = 12;
      } else if (item.account.accountNumber < 1000000) {
        item.destination.numberOfMonths = 60;
      }
      item.destination.residualValue = 0;
    };

    vm.totalChanged = function(l) {
      vm.purchase.totalAmount  = vm.purchase.totalCurrencyAmount / vm.purchase.currencyExchangeRate;
      console.log("total changed", vm.purchase.totalAmount);
      var calculation = vm.purchase.totalAmount;
      if (calculation && calculation.length > 0) {
        if (calculation.indexOf("=") > -1) {
          calculation = calculation.replace("=", "");
          vm.purchase.totalAmount = roundTwoDecimals(
            parseFloat(eval(calculation))
          );
        }
      }
      var numOfFiledLines = 0;
      angular.forEach(vm.purchase.Lines, function(line, key) {
        if (Math.abs(line.amount) > 0) {
          numOfFiledLines += 1;
        }
      });
      if (numOfFiledLines < 2) {
        var line = l;
        if (!l && vm.purchase.Lines) {
          line = vm.purchase.Lines[0];
        }
        if (line && line.vatCode) {
          if (line.vatCode.secondAccount !== undefined) {
            vm.purchase.Lines[0].amount = roundTwoDecimals(
              vm.purchase.totalAmount
            );
          } else if (line.vatCode.rates) {
            var invoiceDate = moment(vm.purchase.invoiceDate);
            var percentage = $rootScope.getVatCodePercentage(
              line.vatCode,
              invoiceDate
            );
            vm.purchase.Lines[0].amount = roundTwoDecimals(
              (vm.purchase.totalAmount / (percentage + 100)) * 100
            );
          }
        }
      }
    };

    vm.purchaseGrandTotal = function() {
      var total = 0;

      angular.forEach(vm.purchase.Lines, function(line, key) {
        total += line.amount + vm.calculateTax(line);
        if (line.vatCode && line.vatCode.secondAccount)
          total -= vm.calculateTax(line);
      });

      return total;
    };``

    vm.calculateTax = function(line) {
      if (line.vatCode && line.vatCode.rates) {
        var invoiceDate = moment(vm.purchase.invoiceDate);
        return roundTwoDecimals(
          ($rootScope.getVatCodePercentage(line.vatCode, invoiceDate) *
            line.amount) /
          100
        );
      } else {
        return 0;
      }
    };

    vm.calculateBookingDifference = function() {
      return roundTwoDecimals(
        vm.purchase.totalAmount - vm.purchaseGrandTotal()
      ); /// + vm.invoiceSubTotal();
    };

    vm.saveDisabled = function() {
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));

      if (
        (vm.purchase.roundingDifference &&
          vm.showRoundingDifferenceCheckbox()) ||
        diff === 0
      ) {
        return false;
      }
      return true;
    };
    vm.showRoundingDifferenceCheckbox = function() {
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));
      if (diff < 0.05 && diff !== 0) {
        return true;
      }
      return false;
    };

    vm.removePurchase = function(purchase) {
      if ($state.current.name === "app.company.new.purchases") {
        $("#removeAttachmentModal").modal("show");
      } else {
        $("#removeModal").appendTo("#app-content");
        $("#removeModal").modal("show");
      }
    };

    vm.returnToList = function() {
      console.log('returnToList before');

      $timeout(function() {
        $state.go("app.company.purchases.list");
        console.log('returnToList after timeout');
      }, 500);
    };

    vm.removeInbox = function() {
      console.log('removeModal hide before');
      $("#removeModal").modal("hide");
      console.log('removeModal hide after');

      Purchase.deleteById({
        id: vm.purchase.id
      }).$promise.then(function() {
        console.log('return to list');
        vm.returnToList();
      }).catch(function(response){
        console.log('failed to remove to inbox', response)
        window.swal("Mislukt", response.data.error.message, "error");
      });
    };

    vm.removePermanently = function() {
      console.log('removeModal hide before');
      console.log('removeModal hide after');
      $("#removeModal").modal("hide");
      Purchase.removePermanent({
        id: vm.purchase.id
      }).$promise.then(function() {
        vm.returnToList();
      }).catch(function(response){
        console.log('failed to remove permanently', response)
        window.swal("Mislukt", response.data.error.message, "error");
      });
    };

    vm.savePurchase = function() {
      vm.saving = true;
      var purchaseCopy = $.extend({}, vm.purchase);
      // purchaseCopy.invoiceDate = moment(
      //   vm.invoiceDateText,
      //   "DD-MM-YYYY"
      // ).toDate();
      // purchaseCopy.dueDate = moment(vm.purchase.dueDate, "DD-MM-YYYY").toDate();
      // purchaseCopy.journalDate = moment(
      //   vm.journalDateText,
      //   "DD-MM-YYYY"
      // ).toDate();

      if (vm.purchase.vendor) {
        purchaseCopy.vendorId = vm.purchase.vendor.id;
        delete purchaseCopy.vendor;
      }
      purchaseCopy
        .$save()
        .then(function() {
          vm.close(true);
          vm.saving = false;
        })
        .catch(function(response) {
          vm.saving = false;
          if (response.data && response.data.error) {
            window.swal(
              "Opslaan mislukt",
              response.data.error.message,
              "error"
            );
          } else {
            window.swal("Opslaan mislukt", "Onbekende fout", "error");
          }
        });
    };

    vm.initializeL = function(changeAccounts) {
      if (!vm.purchase.Lines || vm.purchase.Lines.length === 0) {
        vm.purchase.Lines = [];
        vm.addItem();
        vm.totalChanged();
      } else {
        vm.purchase.Lines.forEach(function(line) {
          if ((changeAccounts || !line.account) && vm.accounts) {
            let accounts = vm.accounts;
            if(accounts.length > 0 && (accounts[0].localCount > 0 || accounts[0].globalCount > 0)) {
              line.account = accounts[0];
            }else {
              line.account = {}
            }
          } else if (changeAccounts) {
            line.account = {};
          }
          vm.accountChanged(line);
        });
      }
      // vm.totalChanged();
    };

    function initNewPurchase() {
      vm.purchase = new Purchase();
      vm.purchase.type = "invoice";
      vm.vendor = new Vendor({ type: "specific" });
      vm.purchase.currency = 'EUR';
      vm.purchase.currencyExchangeRate = 1

      vm.invoiceDateChanged();
      vm.purchase.attachmentId = attachment.id;
      $scope.$parent.transaction = vm.purchase;

      if (!attachment) {
        return null;
      }

      var extractedData = attachment.extractedData;
      var transactionProposal = attachment.transactionProposal;
      if (extractedData && transactionProposal) {
        // vm.purchase.totalAmount = transactionProposal.totalAmount;
        vm.purchase.totalCurrencyAmount = transactionProposal.totalAmount;
        vm.purchase.currency = transactionProposal.currency || 'EUR';
        vm.purchase.type = transactionProposal.type;
        vm.purchase.invoiceNumber = transactionProposal.invoiceNumber;
        vm.purchase.invoiceDate = transactionProposal.invoiceDate;
        vm.purchase.time = transactionProposal.time;
        vm.purchase.dueDate = transactionProposal.dueDate;
        if(vm.purchase.type === "receipt") {
          vm.purchase.dueDate = vm.purchase.invoiceDate
        }
        vm.purchase.Lines = transactionProposal.Lines;
        if (transactionProposal.vendorId) {
          vm.purchase.vendor = new Vendor(transactionProposal.vendor);
          Vendor.get({
            id: transactionProposal.vendorId
          }).$promise.then(function(vendor) {
            vm.setVendor(vendor);
          });
        }
        if (extractedData.amounts) {
          vm.extractedNumbers = extractedData.amounts;
        }
        console.log("Extracted text is ", extractedData.text);
        vm.invoiceNumberSuggestions = [];
        if (extractedData.text) {
          vm.invoiceNumberSuggestions = $rootScope.invoiceNumberSuggestions(
            extractedData.text
          );
        }
        vm.invoiceNumberSuggestions.push(moment().format("YYYYMMDD"));
      }
      console.log("Extracted data:", extractedData);
      vm.invoiceDateChanged();
      vm.purchase.Attachment = attachment;
      $scope.$parent.transaction = vm.purchase;
      vm.totalChanged();
    }

    function loadPurchase() {
      Purchase.get({
        id: $stateParams.id,
        filter: { include: ["Attachment", "vendor", 'user', 'events'] }
      }).$promise.then(function(purchase) {
        console.log("purchase loaded Lines is", purchase.Lines);
        vm.purchase = purchase;
        vm.purchase.vendor = new Vendor(vm.purchase.vendor);
        console.log("init loaded purchase", vm.purchase.Lines);
        refreshAccounts();
        refreshVatCodes();
        refreshExchangeRates();
        $scope.$parent.transaction = vm.purchase;
      });
    }

    if ($state.current.name === "app.company.new.purchases") {
      attachment = $state.params.attachment;
      if (attachment) {
        attachment = Attachment.get({
          id: $stateParams.attachment.id
        });
        attachment.$promise.then(function() {
          initNewPurchase();
        })
      } else {
        attachment = Attachment.get({
          id: $stateParams.id
        });
        attachment.$promise.then(function() {
          initNewPurchase();
        });
      }
    } else {
      if ($state.params.purchase) {
        vm.purchase = $state.params.purchase;
        $scope.$parent.transaction = vm.purchase;
      }
      loadPurchase();
    }

    vm.vendorSelect = function(item) {
      var vendor = item;
      vm.setVendor(vendor);

      if (vendor && vendor.createNew) {
        $scope.openNewContactModal();
      }
    };

    vm.getPurchasesUrl = function(vendor) {
      return `/${$rootScope.currentCompany.slug}/purchases?search=${vendor.name}`
    }

    vm.setVendor = function(vendor) {
      vm.purchase.vendor = vendor;
      vm.invoiceDateChanged();
      vm.enteredInvoiceNumber();
      refreshVatCodes();
      refreshAccounts(true);
    };

    function loadVendors(query) {
      if(!$rootScope.isBookkeeper()) {
        return;
      }
      var type = undefined;
      if (vm.purchase.type === "receipt") {
        type = "general";
      }

      Vendor.search(
        {
          type: type,
          query: query,
          limit: 35
        },
        function(vendors) {
          vm.vendors = vendors;

          var newVendor = new Vendor({
            name: query,
            tradeName: query,
            createNew: true,
            type: "specific",
            bankAccountNumbers: [""]
          });
          if (vm.purchase.type === "receipt") {
            newVendor.type = "general";
          }
          if (!query || query.length < 1) {
            vm.vendors.unshift(newVendor);
          }else {
            vm.vendors.push(newVendor);
          }
        }
      );
    }

    vm.refreshVendorList = function(query) {
      loadVendors(query);
    };

    vm.refreshVendorList = function(query) {
      loadVendors(query);
    };

    vm.saveVendor = function(vendor) {
      Vendor.upsert(vendor, function(vendor) {
        vm.setVendor(vendor);
        refreshAccounts(true);
        $scope.closeContactModal();
      }, function(response) {
        window.swal("Opslaan mislukt", response.data.error.message, "error");
      });
    };

    vm.onVendorCancel = function() {
      if (vm.purchase.vendor && vm.purchase.vendor.createNew) {
        vm.purchase.vendor = null; // set vendor to null if new vendor creation is canceled
      }
      $scope.closeContactModal();
    };
  });
